import { Pipe, PipeTransform } from '@angular/core';
import { SizeTranslatableSchema } from '@app/schemas/size';

@Pipe({
  name: 'sizeTranslate',
})
export class SizeTranslatePipe implements PipeTransform {

  public transform(size: SizeTranslatableSchema | null | undefined, lang: string | 'fallback'): string | undefined {
    if (!size) {
      return undefined;
    }

    if (lang === 'fallback') {
      return size.translations[size.fallback];
    }

    return size.translations[lang] || size.translations[size.fallback];
  }

}
